import { useSelector } from 'react-redux'
import { getFetching, getOrders } from 'lib/core/data/customer/orders/selectors'

export const useOrders = () => {
  const orders = useSelector(getOrders)
  const isFetching = useSelector(getFetching)

  return {
    orders,
    isFetching
  }
}
